import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import blog1 from "./Images/event1.jpg";
import blog2 from "./Images/event2.jpg";
import blog3 from "./Images/event3.jpg";

const blogPosts = [
  {
    title: "Best Daily Deals for a Healthy Life",
    date: "August 2, 2025",
    description: "Fuel your day with smart savings! Explore our top health-friendly offers designed to keep your body strong.",
    image: blog1,
  },
  {
    title: "5 Ways to Save More on Daily Shopping",
    date: "August 2, 2025",
    description: "Learn how to make the most out of Daily Go’s deals with simple shopping hacks. Because saving every day adds up.",
    image: blog2,
  },
  {
    title: "Pantry Staples You Shouldn’t Miss",
    date: "August 2, 2025",
    description: "Stock up the smart way! Our bulk deals on rice, lentils, and oils are perfect for your weekly essentials.",
    image: blog3,
  },
];

const BlogSection = () => {
  return (
    <section className="bg-[#fafafa] py-24 px-6 md:px-16">
      
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-[2px] bg-yellow-500"></span>
              <h4 className="text-yellow-500 font-bold tracking-[0.2em] uppercase text-xs">
                Our Blog Post
              </h4>
            </div>

            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
              Latest <span className="text-yellow-500">Articles.</span>
            </h2>
          </div>
          
          <div className="mt-6 md:mt-0">
            <Link 
              to="/BlogsIndex" 
              className="text-gray-600 hover:text-yellow-500 text-sm font-semibold uppercase tracking-widest transition"
            >
              View All Posts →
            </Link>
          </div>
        </div>

        {/* Grid */}
        <div className="grid gap-8 md:grid-cols-3">
          {blogPosts.map((post, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-500 flex flex-col"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />

                {/* Light gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center text-yellow-500 text-xs font-semibold uppercase tracking-wide mb-4">
                  <Calendar className="w-3 h-3 mr-2" />
                  {post.date}
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-yellow-500 transition">
                  {post.title}
                </h3>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-8 line-clamp-2">
                  {post.description}
                </p>

                {/* CTA */}
                <div className="mt-auto">
                  <Link
                    to="/BlogsIndex"
                    className="inline-flex items-center text-gray-900 font-semibold text-sm group/link"
                  >
                    Read Story
                    <div className="ml-3 p-2 rounded-full border border-gray-200 group-hover/link:bg-yellow-500 group-hover/link:border-yellow-500 transition">
                      <ArrowRight className="w-4 h-4 group-hover/link:text-black" />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BlogSection;